import styled, { css } from 'styled-components';
import { RouterLink, RouterLinkProps } from '@redux-first-router-link';

interface NavItemProps {
  selected: boolean;
}

export const NavItem = styled(RouterLink)<RouterLinkProps & NavItemProps>`
  text-wrap: nowrap;

  ${({ theme }) => theme.typography.xSmall}
  height: ${({ theme }) => theme.x8space * 10}px;
  line-height: ${({ theme }) => (theme.x8space - 0.2) * 10}px;
  padding: 0 ${({ theme }) => theme.x5spacePx / 4}px;
  display: inline-block;
  position: relative;
  color: ${({ theme }) => theme.color.textSofter};

  /* Avoid blue tap color on Chrome on Android */
  -webkit-tap-highlight-color: transparent;

  > span {
    position: relative;
    z-index: 1;
  }

  &:after {
    content: '';
    display: block;
    position: absolute;
    inset: 13px 1px 15px 1px;
    border-radius: ${({ theme }) => theme.x3spacePx / 4}px;
    background-color: transparent;
    transition: background-color 0.15s;
  }
  &:focus-visible:after,
  &:hover:after {
    background-color: ${({ theme }) => theme.color.spaceGray};
  }

  &:focus,
  &:hover {
    color: ${({ theme }) => theme.color.textSolid};
  }

  &:active:after {
    opacity: 0.7;
  }

  transition: color 0.15s;
  ${({ selected }) =>
    selected &&
    css`
      color: ${({ theme }) => theme.color.textSolid};
    `};
`;
